import { createSlice } from '@reduxjs/toolkit';
import { EnvironmentSliceState } from '../../types/redux/states/EnvironmentSliceState';

export const environmentSliceInitialState: EnvironmentSliceState = {
  env: 'prod',
  sha: '--',
  apmUrl: null,
  rootDomain: null
};

export const EnvironmentSlice = createSlice({
  name: 'environment',
  initialState: environmentSliceInitialState,
  reducers: {}
});
